
import React from 'react';
import useRouteGuard from '@/hooks/useRouteGuard';

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
  isAuthenticated: () => boolean | Promise<boolean>;
  loadingComponent?: React.ReactNode;
}

/**
 * Component that guards routes requiring authentication
 */
const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  redirectTo = '/login',
  isAuthenticated,
  loadingComponent,
}) => {
  const { loading } = useRouteGuard({
    redirectTo,
    shouldRedirect: async () => {
      try {
        const isAuth = await isAuthenticated();
        return !isAuth;
      } catch (error) {
        console.error("Authentication check failed:", error);
        return true; // Redirect to login on error
      }
    },
  });

  if (loading) {
    return loadingComponent ? (
      <>{loadingComponent}</>
    ) : (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-12 w-12 bg-primary/20 rounded-full"></div>
          <div className="mt-4 text-joerg-600">Ladevorgang läuft...</div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
